module.exports = __webpack_public_path__ + "img/LogoEN.edc97d69.png";